import React from 'react';
import PropTypes from 'prop-types';

function PaginationLink({ value, page, updatePage }) {
  function updatePageWithValue(e) {
    e.preventDefault();
    switch (value) {
      case '<< Previous':
        updatePage(page - 1);
        break;
      case 'Next >>':
        updatePage(page + 1);
        break;
      default:
        updatePage(value);
    }

    document.getElementById('top-of-results') && document.getElementById('top-of-results').scrollIntoView();
  }

  const pageLink = value === page ? 
    <span aria-label="current page">{value}</span> :
    <a href="#change-page"
      onClick={(e) => updatePageWithValue(e)}
      aria-label={value === '<< Previous' ? 'Previous Page' : value === 'Next >>' ? 'Next Page' : 'Page ' + value}
    >
      {value}
    </a>


  return pageLink;
}

export default PaginationLink;

PaginationLink.propTypes = {
  value: PropTypes.any.isRequired,
  page: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/PaginationLink.js